import { useModal } from '@/features/Modal/Modal.hooks'
import { DrawerModalListItem } from '@/features/Modal/Modal.types'
import { DrawerModalList } from '@/features/Modal/ui/DrawerModalList/DrawerModalList'
import { AppRoutes } from '@/routes'
import { useRouter } from 'nextjs-toploader/app'
import React, { useCallback } from 'react'

const SUPPORT_EMAIL = 'support@godefi.me'
const SUPPORT_SUBJECT = 'Lost wallet access'

export function AuthLostWallet() {
  const { destroyModal } = useModal()
  const router = useRouter()

  const handleSupport = useCallback(() => {
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(SUPPORT_SUBJECT)}`
    destroyModal()
  }, [destroyModal])

  const handleLogin = useCallback(() => {
    router.push(AppRoutes.PUB_EMAIL)
    destroyModal()
  }, [destroyModal, router])

  const list: DrawerModalListItem[] = [
    {
      text: 'Write to support',
      icon: null,
      visible: true,
      onClick: handleSupport,
    },
    {
      text: 'Login by email',
      icon: null,
      visible: true,
      onClick: handleLogin,
    },
  ]
  return (
    <DrawerModalList
      list={list}
    />
  )
}
